import { Avatar, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { siteInfo } from "../utils/SiteInfo";
import {
  CloudServerOutlined,
  GoldOutlined,
  HomeOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { IoCashOutline } from "react-icons/io5";
import { IoSparklesOutline, IoChevronForwardOutline } from "react-icons/io5";
import { setActivated } from "../reducers/authReducer";

const masterLinks = [
  { label: "Ideas", path: "/ideas" },
  { label: "Office Complains", path: "/office-complains" },
  { label: "Master Order Report", path: "/master-order-report" },
  { label: "Master Payment Report", path: "/master-payment-report" },
  { label: "Master Due Report", path: "/master-due-report" },
  { label: "Master Activity Log", path: "/master-activity-log" },
  { label: "Master Balance Report", path: "/master-balance-report" },
];

export default function Navbar(props) {
  const profile = useSelector((state) => state.auth?.profile);
  const location = useLocation();
  const navigate = useNavigate();

  const [masterOpen, setMasterOpen] = useState(false);

  let activated = siteInfo.isActivated();

  let isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const isMaster = siteInfo.masterAccess?.includes(profile?.phone);

  let routes = [
    { path: "/", title: "Dashboard", icon: HomeOutlined },
    { path: "/purchasing", title: "Purchasing", icon: CloudServerOutlined },
    { path: "/orders", title: "Orders", icon: GoldOutlined },
    { path: "/customers", title: "Customers", icon: TeamOutlined },
    { path: "/payments", title: "Payments", icon: IoCashOutline },
    { path: "/admins", title: "Admins", icon: UsergroupAddOutlined },
  ];

  const getRouteName = (pathname) => {
    let found = routes.find((el) => el.path === pathname);
    if (found) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <found.icon size={18} color="#fff" />
          <span style={{ color: "#fff", marginLeft: 8, textTransform: "capitalize" }}>
            {found.title}
          </span>
        </div>
      );
    } else {
      let arr = pathname.split("/");
      let name = arr[arr.length - 1];

      console.log(name);

      name = name && typeof name === "string" ? name?.split("-").join(" ") : name;

      if (pathname.includes("/create-post")) name = "Create Post";
      if (pathname.includes("/edit-post")) name = "Edit Post";
      if (pathname.includes("/delivery/")) name = "Invoice";
      if (pathname.includes("/cash-counter/")) name = "Cash Counter";
      if (pathname.includes("/campaign/")) name = "Campaign Details";
      if (pathname.includes("agent/orders")) name = "Agent Orders";
      if (pathname.includes("/agent/withdraw/")) name = "Agent Withdraw";
      if (pathname.includes("/rmb-transaction-details")) name = "RMB Transaction Details";
      if (pathname.includes("/badge/customer")) name = "Customer Report";

      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <span style={{ color: "#fff", textTransform: "capitalize" }}>{name}</span>
        </div>
      );
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const intervalId = setInterval(() => {
      let activated = siteInfo.isActivated();
      if (activated) {
        dispatch(setActivated(true));
      } else {
        dispatch(setActivated(false));
      }
      if (!activated && location.pathname !== "/" && location.pathname !== "/login") {
        window.location.href = "/";
      }
    }, 3000);
    return () => clearInterval(intervalId);
  }, [location.pathname]);

  // close modal on navigation
  useEffect(() => {
    setMasterOpen(false);
  }, [location]);

  return (
    <>
      {location.pathname !== "/login" && (
        <nav
          style={{
            backgroundColor: siteInfo.navColor,
            padding: "0px 1.5rem",
            position: "fixed",
            boxShadow: "0 1px 16px rgba(0,0,0,.1)",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            zIndex: 1,
            height: "60px",
            color: "white",
            top: 0,
            left: 220,
            right: 0,
            display: isAuthenticated ? "block" : "none",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            {/* Left — page title */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              {getRouteName(location.pathname)}
            </div>

            {/* Right — Master button + profile */}
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>

              {/* Master button (desktop only, gated) */}
              {isMaster && window?.innerWidth > 768 && activated && (
                <button
                  onClick={() => setMasterOpen(true)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    background: "rgba(255,255,255,0.15)",
                    border: "1px solid rgba(255,255,255,0.3)",
                    borderRadius: 20,
                    padding: "5px 14px",
                    color: "#fff",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 600,
                    letterSpacing: 0.3,
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.25)")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
                >
                  <IoSparklesOutline size={15} color="#fbbf24" />
                  Master
                </button>
              )}

              {/* Profile */}
              <Link href="/profile" className="logout">
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <Avatar style={{ backgroundColor: "#fde3cf", color: "#f56a00" }}>U</Avatar>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginLeft: "0.5rem",
                    }}
                  >
                    <span style={{ lineHeight: "18px", fontWeight: "bold", color: "#f0f0f0" }}>
                      {profile?.name ? profile?.name : "Administration"}
                    </span>
                    <span
                      style={{
                        lineHeight: "18px",
                        fontWeight: "bold",
                        color: "#eee",
                        fontSize: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      {profile?.phone ? profile?.phone : "role"}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </nav>
      )}

      {/* Master links modal */}
      <Modal
        title={
          <span style={{ fontWeight: 700, fontSize: 15, display: "flex", alignItems: "center", gap: 6 }}>
            <IoSparklesOutline size={16} color="#f59e0b" /> Master Panel
          </span>
        }
        open={masterOpen}
        onCancel={() => setMasterOpen(false)}
        footer={null}
        centered
        bodyStyle={{ padding: "12px 16px 16px" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {masterLinks.map(({ label, path }) => (
            <div
              key={path}
              onClick={() => { navigate(path); setMasterOpen(false); }}
              style={{
                padding: "13px 16px",
                borderRadius: 10,
                background: "#f7f8fa",
                cursor: "pointer",
                fontWeight: 500,
                fontSize: 14,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#eceef2")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#f7f8fa")}
            >
              <span>{label}</span>
              <IoChevronForwardOutline size={15} color="#aaa" />
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}
